<template>
  <main :class="overlap ? '-mt-24' : ''" class="flex-1 relative pb-8">
    <div class="mt-8">
      <div class="mx-auto px-4 sm:px-6 lg:px-8">
        <slot/>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'BaseContent',

  props: {
    overlap: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
